import { render, staticRenderFns } from "./BudgetSubType.vue?vue&type=template&id=0a710456&scoped=true"
import script from "./BudgetSubType.vue?vue&type=script&lang=js"
export * from "./BudgetSubType.vue?vue&type=script&lang=js"
import style0 from "./BudgetSubType.vue?vue&type=style&index=0&id=0a710456&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a710456",
  null
  
)

export default component.exports